import _objectSpread from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import SlotCounterStationSheet from '@/components/Counter/SlotCounterStationSheet';
import SlotCounterStationSaleSheet from '@/components/Counter/SlotCounterStationSaleSheet';
import dateUtils from '@/utils/dateUtil';
import { mapGetters } from 'vuex';
export default {
  name: 'StationSheet',
  components: {
    SlotCounterStationSheet: SlotCounterStationSheet,
    SlotCounterStationSaleSheet: SlotCounterStationSaleSheet
  },
  data: function data() {
    return {
      datePickerValue: dateUtils.todayTimestamp() * 1000 - 86400 * 1000,
      refIndex: 0,
      pickerOptionsLimit: {
        disabledDate: function disabledDate(pTime) {
          return pTime.getTime() < new Date() - 91 * 86400 * 1000 || pTime.getTime() > new Date();
        }
      }
    };
  },
  created: function created() {},
  computed: _objectSpread(_objectSpread({}, mapGetters('stations', ['asyncStations'])), mapGetters('user', ['userInfo'])),
  methods: {
    tabClick: function tabClick(el) {
      this.refIndex += 1;
    }
  }
};